/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_td_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare two blocks of text and see exactly what changed — added lines in green, removed lines in red — line by line, in your browser.`)
};

const es_td_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compara dos bloques de texto y ve exactamente qué cambió — líneas agregadas en verde, líneas eliminadas en rojo — línea por línea, en tu navegador.`)
};

const de_td_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleiche zwei Textblöcke und sehe genau, was sich geändert hat – hinzugefügte Zeilen in Grün, entfernte Zeilen in Rot – Zeile für Zeile, in deinem Browser.`)
};

const nl_td_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergelijk twee blokken tekst en zie exact wat er is veranderd — toegevoegde regels in groen, verwijderde regels in rood — regel voor regel, in uw browser.`)
};

const fr_td_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparez deux blocs de texte et voyez exactement ce qui a changé — les lignes ajoutées en vert, les lignes supprimées en rouge — ligne par ligne, dans votre navigateur.`)
};

const it_td_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronta due blocchi di testo e vedi esattamente cosa è cambiato — righe aggiunte in verde, righe rimosse in rosso — riga per riga, nel tuo browser.`)
};

const pt_br2_td_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare dois blocos de texto e veja exatamente o que mudou — linhas adicionadas em verde, linhas removidas em vermelho — linha por linha, no seu navegador.`)
};

const pt_td_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare dois blocos de texto e veja exatamente o que mudou — linhas adicionadas em verde, linhas removidas em vermelho — linha a linha, no seu navegador.`)
};

const ja_td_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2つのテキストブロックを比較し、何が変わったかを正確に確認します。追加された行は緑、削除された行は赤でハイライト表示されます。行ごとにブラウザで確認できます。`)
};

const zh_td_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比较两段文本，逐行精确查看发生了哪些变化——新增的行以绿色显示，删除的行以红色显示——一切都在你的浏览器中完成。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const td_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.td_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("td_intro", locale)
	if (locale === "en") return en_td_intro(inputs)
	if (locale === "es") return es_td_intro(inputs)
	if (locale === "de") return de_td_intro(inputs)
	if (locale === "nl") return nl_td_intro(inputs)
	if (locale === "fr") return fr_td_intro(inputs)
	if (locale === "it") return it_td_intro(inputs)
	if (locale === "pt-BR") return pt_br2_td_intro(inputs)
	if (locale === "pt") return pt_td_intro(inputs)
	if (locale === "ja") return ja_td_intro(inputs)
	return zh_td_intro(inputs)
};